firebird

    .config([
        '$stateProvider',
        '$urlRouterProvider',
        '$locationProvider',
        '$qProvider',
        '$translateProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, $qProvider, $translateProvider) {
            $qProvider.errorOnUnhandledRejections(true);
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
            $urlRouterProvider.otherwise('');

            $translateProvider.useStaticFilesLoader({
                prefix: '/i18n/minify/',
                suffix: '.json?v=1793280325966'
            });

            $translateProvider.useSanitizeValueStrategy('sceParameters');
            $translateProvider.preferredLanguage('en-US');

            $stateProvider

                //------------------------------
                // MEETING STATES
                //------------------------------

                .state('meeting-not-found', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-not-found.html');
                        }
                    ],
                    params: { reason: '', data: '', templatePrefix: '' }
                })

                .state('meeting-not-started', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-not-started.html');
                        }
                    ],
                    params: { data: '', templatePrefix: '' }
                })

                .state('meeting-ended', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-ended.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-error', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-error.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-login', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-login.html');
                        }
                    ],
                    params: {
                        appUpdateStatus: false,
                        userAlreadyExists: false,
                        meetingAccessCode: '',
                        templatePrefix: ''
                    }
                })

                .state('meeting-show-electron', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-show-electron.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-active', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-active.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('mobile-host-login', {
                    templateProvider: [
                        'templateCache',
                        function (templateCache) {
                            return templateCache.getTemplate('mobile-host-login.html');
                        }
                    ]
                })

                .state('host-account-page', {
                    templateProvider: [
                        'templateCache',
                        function (templateCache) {
                            return templateCache.getTemplate('mobile-host-account.html');
                        }
                    ]
                })

                .state('meeting-ended-thank-you', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-ended-thank-you.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-key-was-not-provided', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-key-was-not-provided.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-not-supported-vdi', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            let prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-not-supported-vdi.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })
                .state('app-or-browser-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            return templateCache.getTemplate('redesign/browser-or-app-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('camaro-updating', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            return templateCache.getTemplate('redesign/camaro-updating-page-container.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('loading', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'loading.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-full', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-full.html');
                        }
                    ],
                    params: {
                        seats: 0,
                        phoneNumber: '',
                        pin: '',
                        templatePrefix: ''
                    }
                })

                .state('e2ee-meeting-full', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-meeting-full.html');
                        }
                    ],
                    params: {
                        seats: 0,
                        templatePrefix: ''
                    }
                })

                .state('meeting-locked', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-locked-waiting-for-approval', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked-waiting-for-approval.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-locked-join-request-declined', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked-join-request-declined.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('marquee-screenshot', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'marquee-screenshot.html');
                        }
                    ],
                    params: {
                        background: '',
                        logo: '',
                        capturing: false,
                        templatePrefix: ''
                    }
                })

                .state('change-browser', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'change-browser.html');
                        }
                    ],
                    params: {
                        meetingCode: '',
                        presenterGUID: '',
                        templatePrefix: ''
                    }
                })

                .state('meeting-unite-duplicate-login', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-unite-duplicate-login.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                //------------------------------
                // ATTENDEE & CHAT
                //------------------------------
                .state('kicked-from-meeting', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'kicked-from-meeting.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('phone-audio-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'phone-audio-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-active.attendee-list', {
                    views: {
                        'attendee-list': {
                            template: '<attendee-list></attendee-list>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.chat-client', {
                    views: {
                        'chat-client': {
                            template: '<chat-client></chat-client>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.presenter-chat-client', {
                    views: {
                        'presenter-chat-client': {
                            template: '<presenter-chat-client></presenter-chat-client>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.firepad', {
                    views: {
                        firepad: {}
                    },
                    sticky: true
                })

                //------------------------------
                // SETTINGS MODAL
                //------------------------------
                .state('meeting-active.av-settings', {
                    views: {
                        'av-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/mic-webcam-options.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.custom-branding', {
                    views: {
                        'custom-branding': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/custom-branding.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.virtual-assistant', {
                    views: {
                        'virtual-assistant': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/virtual-assistant.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.security-settings', {
                    views: {
                        'security-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/security-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.beta-settings', {
                    views: {
                        'beta-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/beta-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.general-settings', {
                    views: {
                        'general-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/general-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.advanced-settings', {
                    views: {
                        'advanced-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/advanced-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.virtual-background', {
                    views: {
                        'virtual-background': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate(
                                        'redesign/modals/virtual-background-settings.html'
                                    );
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.about-settings', {
                    views: {
                        'about-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/about-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                });
        }
    ])

    //CONFIG CONSTANTS

    .constant('config', {
        api: {
            url: 'https://api.anymeeting-qa.com'
        },
        screenSharingExtensions: {
            chrome: {
                intermediaDirect: {
                    qa: 'iddplifikpclbkdcobmccdenaecjgfjn',
                    staging: 'bofnpmofdkphjhkmmbbbdcgbjojihmln',
                    prod: 'gjlnkcjifijaeogmofjkladngkaaemec'
                },
                intermediaPLR: {
                    qa: 'lemjmehpmhappogocgopgcgdnimoonnf',
                    staging: 'cfmeaejblplpgbbedoloofagfhmhhknj',
                    prod: 'fhclidaigkfhhipiegnfljdlojgafkbo'
                },
                intermediaUB: {
                    qa: 'bacbjeklbndgponcmhnfgifmhmeikhib',
                    staging: 'hlkfapfbdnplbpkokopihkfpmhcjbcao',
                    prod: 'khokimikiadnolmpjephgikejhcnpejn'
                }
            },
            firefox: {
                intermediaDirect: {
                    qa: {
                        windows: '417703/anymeeting_screensharing_extension_qa-0.3.1-fx-windows.xpi',
                        mac: '417702/anymeeting_screensharing_extension_qa-0.3.1-fx-mac.xpi'
                    },
                    staging: {
                        windows: '417705/anymeeting_screensharing_extension_staging-0.3.0-fx-windows.xpi',
                        mac: '417704/anymeeting_screensharing_extension_staging-0.3.0-fx-mac.xpi'
                    },
                    prod: {
                        windows: '417701/anymeeting_screensharing_extension-0.3.0-fx-windows.xpi',
                        mac: '417700/anymeeting_screensharing_extension-0.3.0-fx-mac.xpi'
                    }
                }
            }
        },
        version: 'qa2-ANYAM-123367-omnissa-reactions-handraise-8',
        webinar: {
            handout: false
        },
        // extracted to config.service.ts
        resellerId: {
            qa: {
                intermediaDirect: 100351,
                intermediaPLR: 100354,
                intermediaUB: 100372,
                intermediaAscend: 100405
            },
            staging: {
                intermediaDirect: 100366,
                intermediaPLR: 100369,
                intermediaUB: 100375,
                intermediaAscend: 100405
            },
            prod: {
                intermediaDirect: 100384,
                intermediaPLR: 100393,
                intermediaUB: 100396,
                intermediaAscend: 100405
            }
        },
        appInsights: {
            qa: {
                instrumentationKey: 'b98a5829-4c86-4e70-9355-4fb3249f3727',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            },
            staging: {
                instrumentationKey: 'e865022a-5630-4a8b-9061-3018d104762f',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            },
            prod: {
                instrumentationKey: '9536cba1-5ab7-4cd2-ba94-2baa0faa447f',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            }
        },
        enableOneOnOnePIP: {
            qa: true,
            staging: false,
            prod: false
        },
        // Recurring yearly ranges in 'MM-DD' format (UTC); startDate is inclusive, endDate is exclusive.
        themedFeatures: [
            {
                name: 'halloween',
                startDate: '10-01',
                endDate: '11-01'
            },
            {
                name: 'winter',
                startDate: '12-01',
                endDate: '03-01'
            },
            {
                name: 'spring',
                startDate: '03-20',
                endDate: '05-01'
            }
        ],
        launchDetectionMaxAttemptCount: 5,
        maxCountExplicitlyChosenDeviceHistory: 10,
        banubaClientToken:
            'Qk5CIC+4ZawoXbLyyV7Mq1MrJ+4Cw3ez6AsyglXp79HooP24xkwQtQaBVRcOymjNazkZSByfrPeUaTBgedBcb22t5cWg3q42g6/zQdoVIwzxV52FQARG/1nXWmztNszvJHRxmruMFQdpaZrQnMONL2P/u6tyT6aeQ5kyxobWsIrCYy3D7OYifu8nvvlEZ/FyDmKyLst63O3O8hyLoT+HQCQ6zKTHloaWd1H12UcpegIZefJnLNsFWsKOUeAzxJ2Sh9aC9aLrTrBYi8gi1FMcnoNKqTmIkwtZtaRakk1GX1Bb4epGCDP/7gnvo5wY8M+lSbgYzFLb5/duCqkhC0k/mZPpHZhf0iNoTKb3C17c11QOjFNZ5bbWw6Vnea0tKcgdZr/TskjLbXHSyJ5aaNQtXqS6rvjg8ky6tAPLpHXhgxNJlbyML2LjNDkXqNs17OhBUALYSjVAE5zwvaxPjum/nGLFKMFRHRA6t8N9o0bYLi1j4sLZ0wJo5DfweySwvocNA15QsHaa+Cwcstavfn6z7BGeiOlfC6ig7siGI1BzGPZywhBcXGOLmCp+slewZvOvf4/0AayscoUJIG+fV5gIb2OwoF7M4Zl9lo6bwebOmGg6UL9IVKBC2qVgNYLzll14oaf9FkzqKVqBRC3ovIel4jM='
    });
